import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';

export default function VideoEmbed({ videoUrl }) {
  const containerRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return;

    if (typeof IntersectionObserver === 'undefined') {
      setInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        minHeight: '360px',
        background: '#000',
      }}
    >
      {inView && (
        <ReactPlayer
          url={videoUrl}
          width="100%"
          height="360px"
          controls
          light
          playsinline
          config={{
            youtube: { playerVars: { rel: 0, modestbranding: 1 } },
            file: { attributes: { preload: 'none' } },
          }}
        />
      )}
    </div>
  );
}
